module.exports = __webpack_public_path__ + "static/media/brand-linkedin.03752163.svg";